export const parameterTree: any = [
  {
    active: true,
    displayName: "Input Parameters",
    key: 'input_parameters',
    // assetIcon: "ActiveDirectory.png",
    id: "input_parameters",
    name: "input_parameters",
    isAdd: true,
    order: 1,
    level: 0,
    children: [],
    style: { cursor: 'pointer' }
  },
  {
    active: true,
    displayName: "Output Parameters",
    key: 'output_parameters',
    // assetIcon: "ActiveDirectory.png",
    id: "output_parameters",
    name: "output_parameters",
    isAdd: true,
    order: 1,
    level: 0,
    children: [],
    style: { cursor: 'pointer' }
  }
];


export const variableTree: any = [
  {
    active: true,
    displayName: "Variables",
    key: 'variables',
    // assetIcon: "ActiveDirectory.png",
    id: "variables",
    name: "variables",
    isAdd: true,
    order: 1,
    level: 0,
    children: [],
    style: { cursor: 'pointer' }
  },
  {
    active: true,
    displayName: "Global Variables",
    key: 'global_variables',
    id: "global_variables",
    name: "global_variables",
    isAdd: true,
    order: 2,
    level: 0,
    children: [],
    style: { cursor: 'pointer' }
  }
];

export const executionTree: any = [
  {
    active: true,
    displayName: "Executions",
    key: 'executions',
    actionableIcons:  [  {
                          icon: "refresh-light.svg",
                          key: "refresh",
                        },
                     ],
    id: "executions",
    name: "executions",
    isCheckable: true,
    order: 1,
    level: 0,
    children: [],
    style: { cursor: 'pointer' }
  }
];

export const connectionTree: any = [
  {
    active: true,
    displayName: "Data Connections",
    key: 'connections',
    // assetIcon: "ActiveDirectory.png",
    id: "connections",
    name: "connections",
    order: 1,
    level: 0,
    children: [],
    style: { cursor: 'pointer' }
  }
];

export const recordedAppsTree: any = [
  {
    id: "applications",
    name: "Applications",
    displayName: "Applications",
    icon: "dashboard",
    order: 1,
    level: 0,
    type: "applications",
    view: "applicationOverviewView",
    isTickable: true,
    isTicked: false,
    children: []
  }
];